import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { GoogleLogin } from 'react-google-login'

import { connect } from 'react-redux'
import { fetchLoginToken } from '../actions/users.js'

import { Redirect, withRouter} from 'react-router-dom'

class Login extends Component {
  static propTypes = {
    // data: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  logout = (response) => {

  }

  
  componentDidMount() {
    document.title = "Login - Admin - Better Spaces"
  }
  

  responseGoogle = (response) => {
    const accessToken = response.accessToken;
    const googleId = response.googleId;
    const email = response.profileObj.email;
    const name = response.profileObj.name

    if (accessToken && googleId) {
      const { dispatch } = this.props
      dispatch(fetchLoginToken(accessToken, googleId, email, name))
    }
  }

  render() {
    // eslint-disable-next-line
    const { dispatch } = this.props;
    const token = this.props.token;

    if (token) return <Redirect exact to="/events" />

    return (
      <div style={{height: '100%'}}>
        <div style={{margin: 'auto auto', width: '200px', padding: '200px'}}>

          <GoogleLogin
            clientId="378305061591-nu20vbh5gminn8jtodg9rujmkd66f2a1.apps.googleusercontent.com"
            buttonText="Login"
            onSuccess={this.responseGoogle.bind(this)}
            onFailure={this.responseGoogle.bind(this)}
          />
          <br />
          <br />
          <p style={{width: '100%',  textAlign: 'center'}}>{this.props.error ? this.props.error : ''}</p>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps)  => {
  return {
    ...state.usersReducer
  }
}

export default withRouter(
    connect(mapStateToProps)(Login)
);



// WEBPACK FOOTER //
// ./src/containers/Login.js